<template>
  <div>
    <div>
      <div>
        <div
          class="option-square p-3"
          @click="lastSettings()"
          v-if="showLastSettings"
        >
          <div class="top-panel">
            <h6 class="m-0">{{ t("LASTSETTINGS") }}</h6>
          </div>
          <div class="mt-3 text-end">
            <h6 class="color-green mb-0">
              {{ t("AMOUNT") }}:
              {{ currencyFormat(lastPayment.paymentAmount) }}
            </h6>
            <h6 class="color-green">
              {{ t("METHOD") }}:
              {{ t(lastPayment.paymentMethod) }}
            </h6>
          </div>
        </div>
      </div>
      <h4
        class="color-black mt-3"
        v-if="
          Object.keys(lastPayment).length > 0 &&
          lastPayment.paymentAmount >= minimumPaymentAmount
        "
      >
        {{ t("ORPLEASESELECT") }}
      </h4>
      <h4 class="color-black mt-3" v-else>
        {{ t("PLEASESELECT") }}
      </h4>
      <div class="explainer-div">
        <img
          alt="piggy"
          :src="`${useAsset('img/credit-line/payment-piggy.png')}`"
          class=""
        />
        <h6>{{ t("YOUAREINCONTROL") }}</h6>
      </div>
    </div>
    <div id="options" class="mt-2">
      <div class="option-square p-3" @click="selectAmount('minimum')">
        <div class="top-panel">
          <h6 class="m-0">{{ t("MINIMUMPAYMENT") }}</h6>
          <h6 class="color-green">
            {{ currencyFormat(minimumPaymentAmount) }}
          </h6>
        </div>
        <div>
          <p class="mb-0">{{ t("MINIMUMPAYMENTEXPLAINER") }}</p>
        </div>
      </div>
      <div class="option-square p-3 mt-3" @click="selectAmount('custom')">
        <div class="top-panel">
          <h6 class="m-0">{{ t("CUSTOMIZE") }}</h6>
          <h6 class="color-green">{{ t("ENTERCUSTOM") }}</h6>
        </div>
        <div>
          <p class="mb-0">{{ t("CUSTOMPAYMENT") }}</p>
        </div>
      </div>
      <div class="option-square p-3 mt-3" @click="selectAmount('payoff')">
        <div class="top-panel">
          <h6 class="m-0">{{ t("PAYOFF") }}</h6>
          <h6 class="color-green">{{ currencyFormat(payableToday) }}</h6>
        </div>
        <div>
          <p class="mb-0">{{ t("PAYOFFEXPLAINER") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import currencyFormat from "@/apps/credit-line/helpers/currencyFormatter.helper";

const { t } = useI18n();
const minimumPaymentAmount = inject("minimumPaymentAmount");
const payableToday = inject("payableToday");
const selectAmount = inject("selectAmount");
const lastSettings = inject("lastSettings");
const showLastSettings = inject("showLastSettings");
const lastPayment = inject("lastPayment");
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.option-square {
  border-width: thin;
  border-color: black;
  border-style: solid;
  border-radius: 15px;
}

.top-panel {
  display: flex;
  justify-content: space-between;
}

.color-green {
  color: $pj-color-green;
}

.color-black {
  color: $pj-color-black;
}

.explainer-div {
  align-items: center;
  display: inline-flex;
}
</style>
